$(document).ready(function(){

  function normalizeName(name) {
    return name.toLowerCase().replace(/ /g, '');
  }

  function hasProductId(title) {
    return title.indexOf('[[') !== -1 && title.indexOf(']]') !== -1;
  }

  function createProductId(id) {
    return '[[' + id.toString() + ']]';
  }

  function getProductId(title) {
    if (hasProductId(title)) {
      var pieces = title.split('[[');
      if (pieces[1] !== undefined) {
        return '[[' + pieces[1].trim();
      }
    }
    return 0;
  }

  var ProductList = $(".collection-featured-grid");     
  
  var desc = $(".SectionHeader__Description");
  desc.find('meta').remove();
  var h3s = $(desc).find('h3');
  var groupedProducts = [];
  
  h3s.each(function() {
    var h3Cloneheading = $(this).clone();
    var clonedProducts = $(ProductList).clone();
    
    $(h3Cloneheading).insertBefore(ProductList);
    $(clonedProducts).insertAfter(h3Cloneheading);
    $(h3Cloneheading).attr('class', 'SectionHeader__Heading Heading u-h1').css('text-align', 'center');
    $(clonedProducts).addClass('bordered');
    var ul = $(this).next('ul');
    var selection = [];

    ul.find('li').each(function(){
      var title = $(this).text();
      var txt = hasProductId(title) ? getProductId(title) : normalizeName(title);
      selection.push(txt);
      groupedProducts.push(txt);
    });

    clonedProducts.find(".collection-featured-grid-item").each(function(){   
      var prod = $(this);
     
      var ttl = normalizeName(prod.find('.card__heading a').text());
      var id = createProductId(prod.find('.card__heading').attr('data-pdpid'));
      if (selection.indexOf(ttl) === -1 && selection.indexOf(id) === -1) {
        prod.remove();
      }
      
    });

    for ( var i in selection) {      
      clonedProducts.find(".collection-featured-grid-item").each(function(){ 
        var prod = $(this);
        var ttl = normalizeName(prod.find('.card__heading a').text());
        var id = createProductId(prod.find('.card__heading').attr('data-pdpid'));            

        if (ttl === selection[i] || id === selection[i]) {
          clonedProducts.append(prod);
        }
      });
    }

    if (clonedProducts.find(".collection-featured-grid-item").length < 1) {
      h3Cloneheading.remove();
      clonedProducts.remove();
    }
  });

  ProductList.find(".collection-featured-grid-item").each(function(){
    var prod = $(this);
    var ttl = normalizeName(prod.find('.card__heading a').text());
    var id = createProductId(prod.find('.card__heading').attr('data-pdpid'));

    if (groupedProducts.indexOf(ttl) !== -1 || groupedProducts.indexOf(id) !== -1) {
      prod.remove();
    }
  });

});

